import React, { useEffect, useState } from "react";
import { Row, Col, Card, Form } from "react-bootstrap";
import TabellaLista from "../Tabella/TabellaLista";
import { ColumnFilter } from "../table/FilteringTable/ColumnFilter";
import { sports, sportsRoles } from "../Util/enum";

const SportJunior = (props) => {

    const [formData, setFormData] = useState({ assicurato: '', primaryHand: '', primaryFoot: '' });
    const [data_json, setDataJson] = useState(null);

    useEffect(() => {
        if (props.profile && props.profile.junior) {
            const j = props.profile.junior;

            let primaryHand = j.primaryHand || '';
            let primaryFoot = j.primaryFoot || '';
            if (primaryHand === 'RIGHT') primaryHand = 'Destra';
            if (primaryHand === 'LEFT') primaryHand = 'Sinistra';
            if (primaryHand === 'AMBIDEXTROUS') primaryHand = 'Ambidestro';
            if (primaryFoot === 'RIGHT') primaryFoot = 'Destro';
            if (primaryFoot === 'LEFT') primaryFoot = 'Sinistro';
            if (primaryFoot === 'AMBIDEXTROUS') primaryFoot = 'Ambidestro';

            setFormData({ assicurato: j.insured ? 'Si' : 'No', primaryHand, primaryFoot });

            if (j.sports) {
                const rows = [];
                j.sports.forEach((element) => {
                    const sportLabel = (sports.find((s) => s.value === element.sportType) || {}).label || '';
                    const sportRole = (sportsRoles.find((r) => r.value === element.sportRole) || {}).label || '';
                    rows.push({
                        id: element.sportType,
                        sport: sportLabel,
                        level: element.percentageOfLevelsCompletion.toFixed(2) + "%",
                        role: sportRole,
                        skill: element.percentageOfSkillsCompletion.toFixed(2) + "%",
                    });
                });
                setDataJson(rows);
            } else {
                setDataJson(null);
            }
        }
    }, [props]);

    const data_column = [
        { Header: 'Sport', accessor: 'sport', Filter: ColumnFilter },
        { Header: 'Livello', accessor: 'level', Filter: ColumnFilter },
        { Header: 'Ruolo', accessor: 'role', Filter: ColumnFilter },
        { Header: 'Skill', accessor: 'skill', Filter: ColumnFilter },
    ];

    return (
        <Row>
            <Form>
                <Card className="cardAuto">
                    <Card.Header><h4 className="card-title">Informazioni generiche</h4></Card.Header>
                    <Card.Body>
                        <Row className="mt-3">
                            <Col lg={4}>
                                <Form.Label>Mano primaria</Form.Label>
                                <Form.Control className="sid-ro-input" type="text" value={formData.primaryHand} readOnly tabIndex={-1} />
                            </Col>
                            <Col lg={4}>
                                <Form.Label>Piede primario</Form.Label>
                                <Form.Control className="sid-ro-input" type="text" value={formData.primaryFoot} readOnly tabIndex={-1} />
                            </Col>
                            <Col lg={4}>
                                <Form.Label>Assicurato</Form.Label>
                                <Form.Control className="sid-ro-input" type="text" value={formData.assicurato} readOnly tabIndex={-1} />
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
                <TabellaLista
                    cardTitle={'Sport praticati'}
                    hasSearch={false}
                    hasFilter={false}
                    hasAddMore={false}
                    data_column={data_column}
                    data_json={data_json}
                />
            </Form>
        </Row>
    );
};

export default SportJunior;
